
import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function TicketIndex() {
  return (
    <NonFSIndex
      data_type="ticket"
    />
  );
}
